export default {
  DARK: {
    heading: p => p.accentWhite,
    blockTitle: p => p.accentWhite,
    blockParagraph: p => p.accentWhite,
    additionalBlockParagraph: p => p.accentWhite,
    backgroundColor: p => p.tertiaryDark,
    line: p => p.accentWhite,
    smallRhombus: p => p.primaryDark,
    rhombus: p => p.primaryLight
  },
  LIGHT: {
    heading: p => p.primaryDark,
    blockTitle: p => p.primaryDark,
    blockParagraph: p => p.tertiaryDark,
    additionalBlockParagraph: p => p.tertiaryDark,
    backgroundColor: p => p.tertiaryLight,
    line: p => p.tertiaryDark,
    smallRhombus: p => p.tertiaryDark,
    rhombus: p => p.tertiaryDark
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    blockTitle: p => p.tertiaryDark,
    blockParagraph: p => p.tertiaryDark,
    additionalBlockParagraph: p => p.tertiaryDark,
    backgroundColor: p => p.tertiaryExtraLight,
    line: p => p.tertiaryDark,
    smallRhombus: p => p.primaryLight,
    rhombus: p => p.primaryDark
  }
}
